import { render, staticRenderFns } from "./CheckoutRoute.vue?vue&type=template&id=bb0d18d2&"
import script from "./CheckoutRoute.vue?vue&type=script&lang=ts&"
export * from "./CheckoutRoute.vue?vue&type=script&lang=ts&"
import style0 from "./CheckoutRoute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports